import React from "react";
import { Modal, Button } from "react-bootstrap";

const VehicleonboardDetailModal = ({ show, onHide, vehicleonboard }) => {
  if (!vehicleonboard) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };

    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Vehicle On-Board Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          <strong>Vehicle NumberPlate : </strong>
          {vehicleonboard.temp_number}
        </p>

        <p>
          <strong>On-Board Date : </strong>
          {formatDate(vehicleonboard.date)}
        </p>

        <p>
          <strong>Size : </strong>
          {vehicleonboard.size}
        </p>

        <p>
          <strong>Vehicle Company :</strong>{" "}
          {vehicleonboard.vehicle_type?.company || "N/A"}
        </p>

        <p>
          <strong>Leasing Partner : </strong>
          {vehicleonboard.leasing_partner}
        </p>

        <p>
          <strong>Location:</strong> {vehicleonboard.location}
        </p>

        <p>
          <strong>Client :</strong> {vehicleonboard.client?.name || "N/A"}
        </p>

        <p>
          <strong>Handover Supervisor :</strong>{" "}
          {vehicleonboard.handover_supervisor?.name || "N/A"}
        </p>

        <p>
          <strong>Current KM :</strong> {vehicleonboard.currentKm ?? 0}
        </p>

        <p>
          <strong>Service Completed :</strong>{" "}
          {vehicleonboard.serviceCompleted ? "Yes" : "No"}
        </p>

        <p>
          <strong>Last Service KM :</strong> {vehicleonboard.lastServiceKm ?? 0}
        </p>

        <p>
          <strong>Last Service Date :</strong>{" "}
          {formatDate(vehicleonboard.lastServiceDate)}
        </p>

        <p>
          <strong>Last Service Type :</strong>{" "}
          {vehicleonboard.lastServiceType || "N/A"}
        </p>

        <p>
          <strong>Comments:</strong> {vehicleonboard.comments || "N/A"}
        </p>

        {/* Additional Things */}
        <hr />

        <h5 className="mb-3">Additional Things</h5>

        {vehicleonboard.additionalThings?.length > 0 ? (
          <div className="border rounded">
            {vehicleonboard.additionalThings.map((item, index) => (
              <div
                key={item.thing?._id || index}
                className="d-flex justify-content-between align-items-center p-3 border-bottom"
              >
                <strong>{item.thing?.name || "Additional Thing"}</strong>

                {item.photo ? (
                  <a
                    href={item.photo}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    View Photo
                  </a>
                ) : (
                  <span className="text-muted">No Photo</span>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted">No additional things added.</p>
        )}

        <hr />

        <p>
          <strong>Created Date:</strong>{" "}
          {vehicleonboard.createdAt
            ? new Date(vehicleonboard.createdAt).toLocaleDateString()
            : "N/A"}
        </p>

        <p>
          <strong>Updated Date:</strong>{" "}
          {vehicleonboard.updatedAt
            ? new Date(vehicleonboard.updatedAt).toLocaleDateString()
            : "N/A"}
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VehicleonboardDetailModal;
